import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { ResponsiveImg } from '@sorare/core/src/atoms/ui/ResponsiveImg';
import { Bezel } from '@sorare/core/src/atoms/ui/bezels/Bezel';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const InnerWrapper = styled(Vertical)`
  align-items: center;
  padding: var(--intermediate-unit) var(--double-unit);
  height: 100%;
`;
const TeamLogo = styled(ResponsiveImg)`
  width: 36px;
  height: 36px;
  object-fit: contain;

  @media ${tabletAndAbove} {
    width: calc(7 * var(--unit));
    height: calc(7 * var(--unit));
  }
`;
const StyledBezel = styled(Bezel)`
  height: 100%;
  background: var(--c-nl-500);
`;

type Props = {
  pictureUrl: string | null;
  name: string;
  selected?: Nullable<boolean>;
  color?: Nullable<string>;
};
export const ListTile = ({ pictureUrl, name, selected, color }: Props) => {
  const showColor = selected && color;
  return (
    <StyledBezel
      boxShadow={showColor ? `inset 0px -40px 40px -40px ${color}` : undefined}
      borderColor={
        showColor
          ? `linear-gradient(to bottom, var(--c-nd-100) 80%, ${color} 100%)`
          : undefined
      }
    >
      <InnerWrapper center gap={1.5}>
        {!!pictureUrl && <TeamLogo src={pictureUrl} alt="" cropWidth={80} />}
        <LabelS bold className="text-center">
          {name}
        </LabelS>
      </InnerWrapper>
    </StyledBezel>
  );
};
